import arrowUp from "static/icons/icon-arrow-up.svg"
import arrowDown from "static/icons/icon-arrow-down.svg"

const toggleAttr = (els, attr) =>
  els.forEach((el) =>
    el.hasAttribute(attr) ? el.removeAttribute(attr) : el.setAttribute(attr, true),
  )

const toggleCaret = (el) => {
  const img = el.querySelector("img")
  const key = "caret"

  if (img.dataset[key] === "down") {
    img.dataset[key] = "up"
    img.src = arrowUp
  } else {
    img.dataset[key] = "down"
    img.src = arrowDown
  }
}

export default function liveSnow() {
  const ATTR = "data-mobile-hidden"

  const instances = document.querySelectorAll(".live-snow--js")

  ;[...instances].forEach((inst) => {
    const buttons = inst.querySelectorAll("[data-more]")
    const targets = inst.querySelectorAll(`[${ATTR}]`)

    ;[...buttons].forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault()

        toggleAttr([...targets], ATTR)
        toggleCaret(button)
      })
    })
  })
}
